import * as React from 'react';
import { resolve } from 'inversify-react';
import autobind from 'autobind-decorator';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { BrandListView } from './brand-list.view';
import { BrandListDataService } from './brand-list.data';

export class BrandListController extends React.Component<ControllerProps<any>, any> {
    protected dataService: BrandListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = BrandListDataService.make();
    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: BrandSummary) {
        // Check later  TODO
        this.props.history.push(`/general/brands/${item == null ? 'new' : item.id}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false);
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        return <BrandListView
            model={this.dataService}
            setBusy={this.props.setBusy}
            onItemDoubleClicked={this.onItemDoubleClicked}
            {...this.props } />
    }
}



// WEBPACK FOOTER //
// ./src/app/general/brands/list/brand-list.controller.tsx